import {
  Scissors, Trees, Leaf, Snowflake, Sprout, Shrub,
} from "lucide-react";

export const SERVICES = [
  {
    icon: Scissors,
    title: "Lawn Care",
    desc: "Precision mowing, edging, aeration and fertilization programs that keep your turf lush, dense and emerald-green all season long.",
  },
  {
    icon: Sprout,
    title: "Landscape Design",
    desc: "Bespoke, architect-grade designs, from stone patios to layered garden beds, crafted around how you live outdoors.",
  },
  {
    icon: Trees,
    title: "Tree Services",
    desc: "Expert pruning, shaping, removal and health assessments performed by certified arborists with full safety rigging.",
  },
  {
    icon: Snowflake,
    title: "Snow Removal",
    desc: "Reliable residential and commercial plowing, shovelling and salting so your property stays safe through every storm.",
  },
  {
    icon: Shrub,
    title: "Garden Maintenance",
    desc: "Weeding, mulching, deadheading and seasonal planting to keep every bed refined, healthy and effortlessly beautiful.",
  },
  {
    icon: Leaf,
    title: "Seasonal Cleanup",
    desc: "Comprehensive spring and fall cleanups: leaf removal, cutbacks and bed prep for a pristine transition each season.",
  },
];

export const SERVICE_OPTIONS = SERVICES.map((s) => s.title);

export const STATS = [
  { value: "15+", label: "Years of Craft" },
  { value: "500+", label: "Projects Delivered" },
  { value: "100%", label: "Client Satisfaction" },
];

export const GALLERY = [
  { url: "https://images.unsplash.com/photo-1772040942277-b194d9d0b648", alt: "Hot tub on wooden deck surrounded by lush garden", tall: true },
  { url: "https://images.pexels.com/photos/33078884/pexels-photo-33078884.jpeg", alt: "Garden stone path leading to a mountain overlook" },
  { url: "https://images.unsplash.com/photo-1769787670461-dc53c498d38d", alt: "Lush garden with pink and white flowers", tall: true },
  { url: "https://images.unsplash.com/photo-1777997992081-f72db9eda8bd", alt: "Modern home with landscaped garden and pool" },
  { url: "https://images.pexels.com/photos/7998653/pexels-photo-7998653.jpeg", alt: "Zen garden with large stones and plants", tall: true },
  { url: "https://images.unsplash.com/photo-1782203601089-55f664badd93", alt: "Poolside landscaping with lounge chairs and flowers" },
  { url: "https://images.unsplash.com/photo-1718019136589-153f99372c75", alt: "Natural stone path across a manicured lawn" },
  { url: "https://images.unsplash.com/photo-1604400247036-e0b38afce25c", alt: "Vibrant wall of colourful garden flowers", tall: true },
];

export const TESTIMONIALS = [
  {
    quote: "Canopy Grounds transformed our tired backyard into a true sanctuary. Every stone, every plant was placed with intention. Neighbours stop just to look.",
    name: "Sarah Jenkins",
    role: "Homeowner, Brantford",
    img: "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
  },
  {
    quote: "Impeccable, punctual and genuinely passionate about the craft. Our commercial property has never looked more polished, winter plowing included.",
    name: "David Wallace",
    role: "Property Manager",
    img: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
  },
  {
    quote: "From design to the final blade of grass, the team was meticulous. They treat your yard like their own. Worth every dollar and then some.",
    name: "Emily Carter",
    role: "Homeowner, Paris ON",
    img: "https://images.unsplash.com/photo-1580489944761-15a19d654956",
  },
];

export const HERO_BG = "https://images.pexels.com/photos/6204045/pexels-photo-6204045.jpeg";
export const HERO_MID = "https://images.unsplash.com/photo-1769787670461-dc53c498d38d";

export const CONTACT = {
  phone: "416-786-3439",
  email: "info@canopygrounds.com",
  location: "Brantford, Ontario, Canada",
};
